let xsrfToken: string | null = null;

export const setXsrfToken = (token: string) => {
  xsrfToken = token;
};

export const getXsrfToken = () => {
  return xsrfToken;
};

export const clearXsrfToken = () => {
  xsrfToken = null;
};
